/**
 * name 媒体实验室路由
 * author zhang.yingyu
 * createTime 2019-04-01
 **/
angular.module("mediaLaboratoryRouterModule",[])
.config(["$stateProvider",function($stateProvider){
    $stateProvider
        .state("front.plan.medialaboratory.hotpointrelate",{ //热点相关
            url:"/hotpointrelate",
            views:{
                "main@front.plan.medialaboratory":{
                    templateUrl:"./planningCenter/mediaLaboratory/hotPointRelate/main_tpl.html",
                    controller:"hotPointRelateCtrl"
                }
            },
        })
        .state("front.plan.medialaboratory.keyrecommend",{ //线索推荐
            url:"/keyrecommend",
            views:{
                "main@front.plan.medialaboratory":{
                    templateUrl:"./planningCenter/mediaLaboratory/keyRecommend/main_tpl.html",
                    controller:"keyRecommendCtrl"
                }
            },
        })
        .state("front.plan.medialaboratory.timeaxis",{ //热点时间轴
            url:"/timeaxis",
            views:{
                "main@front.plan.medialaboratory":{
                    templateUrl:"./planningCenter/mediaLaboratory/timeAxis/main_tpl.html",
                    controller:"timeAxisCtrl"
                }
            },
        })
        .state("front.plan.medialaboratory.timeaxisdetail",{ //热点时间轴详情
            url:"/timeaxisdetail",
            views:{
                "main@front.plan.medialaboratory":{
                    templateUrl:"./planningCenter/mediaLaboratory/timeAxis/timeAxisDetail/main_tpl.html",
                    controller:"timeAxisDetailCtrl"
                }
            },
        })
        .state("hotpointatlas",{ //热点图谱
            url:"/hotpointatlas?keywords&org&name&title&id",
            views: {
                "": {
                    template: "<div style='background-color:#EFF1F4;'><div ui-view='head'></div><div ui-view='main'></div></div>"
                },
                'head@hotpointatlas': {
                    templateUrl: './planningCenter/mediaLaboratory/hotPointRelate/hotPointAtlas/head/main_tpl.html',
                    controller: 'HeaderController'
                },
                'main@hotpointatlas': {
                    templateUrl:"./planningCenter/mediaLaboratory/hotPointRelate/hotPointAtlas/main_tpl.html",
                    controller:"hotPointAtlasCtrl"
                }
            }
        });
}]);